<template>
    <b-container fluid>
        <b-row>
            <b-col lg="12" sm="12">
                <iq-card>
                    <template v-slot:body>
                        <b-row>
                            <b-col xl="12" lg="12" sm="12">
                                <b-overlay :show="loading" rounded="sm">
                                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                        <b-form @submit.prevent="handleSubmit(register)" @reset.prevent="reset">
                                            <!--    training information -->
                                            <b-row>
                                                <b-col lg="6" sm="6">
                                                    <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="4"
                                                            label-for="fiscal_year_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('globalTrans.fiscal_year') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="formData.fiscal_year_id"
                                                                :options="fiscalYearList"
                                                                id="fiscal_year_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                    <ValidationProvider name="Circular" vid="circular_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="4"
                                                            label-for="circular_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('tp_management.circular_no') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="formData.circular_id"
                                                                :options="circularList"
                                                                id="circular_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                    <b-spinner v-if="moduleSpinLoader && !id" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                                    <ValidationProvider name="Training Title" vid="training_name_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="4"
                                                            label-for="training_name_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('elearning_config.training') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                :disabled="true"
                                                                v-model="formData.training_name_id"
                                                                :options="trainingNameList"
                                                                id="training_name_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                    <b-spinner v-if="moduleSpinLoader && !id" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                                    <ValidationProvider name="Batch" vid="batch_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="4"
                                                            label-for="batch_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('trainer_trainee.batch') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                :disabled="false"
                                                                v-model="formData.batch_id"
                                                                :options="batchList"
                                                                id="trainindsfsg_name_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                    <ValidationProvider name="Evaluation Type" vid="exam_type_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="4"
                                                            label-for="exam_type_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('tp_management.evaluation_type') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="formData.exam_type"
                                                                :options="examTypeList"
                                                                id="exam_type_id"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                    <ValidationProvider name="Total Marks" vid="total_marks" rules="required|integer">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="4"
                                                            label-for="total_marks"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('tp_management.total_marks') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-input
                                                                plain
                                                                v-model="formData.total_marks"
                                                                id="total_marks"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                            </b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                    <ValidationProvider name="Start Time" vid="start_time" rules="required">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="4"
                                                            label-for="start_time"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('tp_management.start_time') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-input
                                                                type="time"
                                                                v-model="formData.start_time"
                                                                id="start_time"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                            </b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                    <ValidationProvider name="End Time" vid="end_time" rules="required">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="4"
                                                            label-for="end_time"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('tp_management.end_time') }} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-input
                                                                type="time"
                                                                v-model="formData.end_time"
                                                                id="end_time"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                            </b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                  <ValidationProvider name="Attachment" vid="attachment" rules="">
                                                    <b-form-group
                                                      class="row"
                                                      label-cols-sm="4"
                                                      label-for="attachment"
                                                      slot-scope="{ valid, errors }"
                                                    >
                                                      <template v-slot:label>
                                                        {{$t('trainer_trainee.attachment')}}
                                                      </template>
                                                      <b-form-file
                                                        placeholder="Choose a file"
                                                        id="customFile"
                                                        v-on:change="onImageChange"
                                                        v-model="formData.attachment"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                      ></b-form-file>
                                                      <div class="invalid-feedback">
                                                        {{ errors[0] }} <br>
                                                        <!-- <span>* Max file size 1 MB and allowed file type: jpg,jpeg,png.</span> -->
                                                      </div>
                                                    </b-form-group>
                                                  </ValidationProvider>
                                                </b-col>
                                             <!--   <b-col lg="6" sm="6" v-if="formData.attachment && id">
                                                  <a class="btn btn-primary" :href="trainingElearningServiceBaseUrl + 'download-attachment?file=uploads/questions/'+formData.attachment">{{$t('tp_management.d_attachment')}}</a>
                                                </b-col>-->
                                            </b-row>
                                            <hr>
                                            <!-- question section -->
                                            <div v-for="(question, index) in formData.details" :key="index">
                                                <iq-card class="p-2">
                                                    <b-row>
                                                        <b-col lg="6" sm="6">
                                                            <ValidationProvider name="Question Type" vid="question_type" rules="required|min_value:1">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="4"
                                                                    label-for="question_type"
                                                                    slot-scope="{ valid, errors }"
                                                                >
                                                                    <template v-slot:label>
                                                                        {{ $t('tp_management.question_type') }} <span class="text-danger">*</span>
                                                                    </template>
                                                                    <b-form-select
                                                                        plain
                                                                        v-model="question.q_type"
                                                                        :options="questionTypeList"
                                                                        id="question_type"
                                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                                    >
                                                                        <template v-slot:first>
                                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                        </template>
                                                                    </b-form-select>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                    </b-row>
                                                    <!-- mcq -->
                                                    <b-row v-if="question.q_type === 2">
                                                        <b-col lg="6" sm="6">
                                                            <ValidationProvider name="Question" vid="question" rules="required">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="4"
                                                                    label-for="question"
                                                                    slot-scope="{ valid, errors }"
                                                                >
                                                                    <template v-slot:label>
                                                                        {{ $t('tp_management.question') }} <span class="text-danger">*</span>
                                                                    </template>
                                                                    <b-form-input
                                                                        plain
                                                                        v-model="question.question"
                                                                        id="question"
                                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                                    >
                                                                    </b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                        <b-col lg="6" sm="6">
                                                            <ValidationProvider name="Marks" vid="marks" rules="required|integer">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="4"
                                                                    label-for="marks"
                                                                    slot-scope="{ valid, errors }"
                                                                >
                                                                    <template v-slot:label>
                                                                        {{ $t('tp_management.marks') }} <span class="text-danger">*</span>
                                                                    </template>
                                                                    <b-form-input
                                                                        plain
                                                                        v-model="question.marks"
                                                                        id="marks"
                                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                                    >
                                                                    </b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                        <b-col lg="6" sm="6" v-for="(item, indx) in question.multiple_option" :key="indx">
                                                            <ValidationProvider name="Option" :vid="'Option' + indx" rules="required">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="4"
                                                                    label-for="'Option' + indx"
                                                                    slot-scope="{ valid, errors }"
                                                                >
                                                                    <template v-slot:label>
                                                                        {{ $t('tp_management.option') + ' ' + (indx + 1) }} <span class="text-danger">*</span>
                                                                    </template>
                                                                    <b-form-input
                                                                        plain
                                                                        :placeholder="$t('tp_management.option') + ' ' + (indx + 1) "
                                                                        v-model="item.option"
                                                                        id="Option"
                                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                                    >
                                                                    </b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                    </b-row>
                                                    <!-- true false and written -->
                                                    <b-row v-if="question.q_type === 1 || question.q_type === 3">
                                                        <b-col lg="6" sm="6">
                                                            <ValidationProvider name="Question" vid="question" rules="required">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="4"
                                                                    label-for="question"
                                                                    slot-scope="{ valid, errors }"
                                                                >
                                                                    <template v-slot:label>
                                                                        {{ $t('tp_management.question') }} <span class="text-danger">*</span>
                                                                    </template>
                                                                    <b-form-input
                                                                        plain
                                                                        v-model="question.question"
                                                                        id="question"
                                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                                    >
                                                                    </b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                        <b-col lg="6" sm="6">
                                                            <ValidationProvider name="Marks" vid="marks" rules="required|integer">
                                                                <b-form-group
                                                                    class="row"
                                                                    label-cols-sm="4"
                                                                    label-for="marks"
                                                                    slot-scope="{ valid, errors }"
                                                                >
                                                                    <template v-slot:label>
                                                                        {{ $t('tp_management.marks') }} <span class="text-danger">*</span>
                                                                    </template>
                                                                    <b-form-input
                                                                        plain
                                                                        v-model="question.marks"
                                                                        id="marks"
                                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                                    >
                                                                    </b-form-input>
                                                                    <div class="invalid-feedback">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                    </b-row>
                                                </iq-card>
                                                <b-row>
                                                    <b-col lg="12" sm="12" class="text-right mb-3">
                                                        <button v-if="index === formData.details.length - 1" type="button" class="btn btn-sm iq-bg-primary" @click.prevent="addQuestion(index)">
                                                            {{ $t('ds_institute_management.add')}}
                                                        </button>
                                                        <button v-if="index > 0" type="button" class="btn btn-sm iq-bg-danger" @click="removeQuestion(index)"
                                                        >
                                                            {{ $t('ds_institute_management.delete')}}
                                                        </button>
                                                    </b-col>
                                                </b-row>
                                            </div>
                                            <div class="row">
                                                <div class="col-sm-3"></div>
                                                <div class="col text-right">
                                                    <b-button type="submit" variant="primary" class="mr-1">{{ saveBtnName }}</b-button>                                                    &nbsp;
                                                    <b-button type="button" variant="danger" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                                </div>
                                            </div>
                                        </b-form>
                                    </ValidationObserver>
                                </b-overlay>
                            </b-col>
                        </b-row>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
import { circularDataApi, questionManagementStoreApi, questionManagementUpdateApi } from '../../api/routes'

export default {
    name: 'FormLayout',
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
        this.getCircularData()
        if (this.id) {
            const tmp = this.getData()
            this.formData.fiscal_year_id = tmp.fiscal_year_id
            this.formData.circular_id = tmp.circular_id
            this.formData.training_name_id = tmp.training_name_id
            this.formData.batch_id = tmp.batch_id
            this.formData.exam_type = tmp.exam_type
            this.formData.total_marks = tmp.total_marks
            this.formData.start_time = tmp.start_time
            this.formData.end_time = tmp.end_time
            this.formData.attachment = tmp.attachment
            this.formData.details = tmp.details
            tmp.details.forEach((item, index) => {
                this.formData.details[index].multiple_option = JSON.parse(item.multiple_option)
            })
        }
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            loading: false,
            moduleSpinLoader: false,
            trainingElearningServiceBaseUrl: trainingElearningServiceBaseUrl,
            tmpFormData: {},
            formData: {
                fiscal_year_id: 0,
                circular_id: 0,
                training_name_id: 0,
                batch_id: 0,
                exam_type: 0,
                total_marks: '',
                start_time: '',
                end_time: '',
                attachment: '',
                details: [
                    {
                        q_type: 0,
                        question: '',
                        marks: '',
                        multiple_option: [
                            {
                                option: ''
                            },
                            {
                                option: ''
                            },
                            {
                                option: ''
                            },
                            {
                                option: ''
                            }
                        ]
                    }
                ]
            },
            circularList: [],
            batchList: [],
            moduleList: [],
            allSyllabusList: [],
            trainerList: [],
            examTypeList: [
                {
                    value: 1,
                    text: this.$i18n.locale === 'en' ? 'Pre-Evaluation' : 'প্রাক-মূল্যায়ন'
                },
                {
                    value: 2,
                    text: this.$i18n.locale === 'en' ? 'Post-Evaluation' : 'সমাপনী'
                }
            ],
            questionTypeList: [
                {
                    value: 1,
                    text: this.$i18n.locale === 'en' ? 'True/False' : 'সত্য মিথ্যা'
                },
                {
                    value: 2,
                    text: this.$i18n.locale === 'en' ? 'MCQ' : 'বহু নির্বাচনী প্রশ্ন'
                },
                {
                    value: 3,
                    text: this.$i18n.locale === 'en' ? 'Written' : 'লিখিত'
                }
            ]
        }
    },
    computed: {
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0).map(item => {
                if (this.$i18n.locale === 'bn') {
                    return { value: item.value, text: item.text_bn }
                } else {
                    return { value: item.value, text: item.text_en }
                }
            })
        },
        trainingNameList: function () {
            const obj = this.$store.state.TrainingElearning.commonObj.trainingNameList.filter(item => item.status === 1)
            return obj.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        }
    },
    watch: {
        'formData.fiscal_year_id': function () {
            this.circularList = this.getCircularList()
        },
        'formData.circular_id': function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getCircularData()
            }
        }
    },
    methods: {
      onImageChange (e) {
        const file = e.target.files[0]
        var reader = new FileReader()
        // eslint-disable-next-line no-return-assign
        reader.onloadend = () => this.formData.attachment = reader.result
        reader.readAsDataURL(file)
      },
        addQuestion (index) {
            this.$refs.form.validate()
            this.formData.details.push({
                q_type: 0,
                question: '',
                marks: '',
                multiple_option: [
                    {
                        option: ''
                    },
                    {
                        option: ''
                    },
                    {
                        option: ''
                    },
                    {
                        option: ''
                    }
                ]
            })
        },
        removeQuestion (index) {
            this.formData.details.splice(index, 1)
        },
        async register () {
            this.loading = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadinState = { loading: false, listReload: true }
            if (this.id) {
                result = await RestApi.putData(trainingElearningServiceBaseUrl, `${questionManagementUpdateApi}/${this.id}`, this.formData)
            } else {
                result = await RestApi.postData(trainingElearningServiceBaseUrl, questionManagementStoreApi, this.formData)
            }
            this.$store.dispatch('mutateCommonProperties', loadinState)
            if (result.success) {
                this.loading = false
                this.$store.dispatch('TrainingElearning/mutateCommonObj', { hasDropdownLoaded: false })
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })
                this.$bvModal.hide('modal-4')
            } else {
                this.loading = false
                this.$refs.form.setErrors(result.errors)
            }
        },
        getData () {
            const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
            return JSON.parse(JSON.stringify(tmpData))
        },
        getCircularList () {
            const obj = this.$store.state.TrainingElearning.commonObj.circularMemoList.filter(item => item.fiscal_year_id === this.formData.fiscal_year_id)
            return obj.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        async getCircularData () {
            if (this.formData.fiscal_year_id && this.formData.circular_id) {
                this.moduleSpinLoader = true
                const result = await RestApi.getData(trainingElearningServiceBaseUrl, circularDataApi, { fiscal_year_id: this.formData.fiscal_year_id, circular_id: this.formData.circular_id })
                if (result.success) {
                    this.formData.training_name_id = result.training
                    this.batchList = result.batch.map((item, index) => {
                      return Object.assign({}, { value: item.batch_d.id, text: item.batch_d.batch, text_bn: item.batch_d.batch_bn })
                    })
                    this.moduleSpinLoader = false
                }
            }
        },
        getSyllabus (id, index, inx) {
            this.formData.routines[index].schedules[inx].syllabusList = this.allSyllabusList.filter(item => item.value === id).map((obj, key) => {
                return { value: obj.value, text: obj.text }
            })
        }
    }
}
</script>
<style scoped>
.overlay {
    position: absolute;
    left: 65%;
    z-index: 9999;
    top: 10px;
    text-align: center;
}
</style>
